import React from "react";
import FadeIn from "react-fade-in";

// COMPONENTS
import walnutsImg from "assets/walnuts.jpg";
import almondsImg from "assets/almonds.jpg";
import flaxImg from "assets/flax.jpg";
import chiaImg from "assets/chia.jpg";
import Title from "components/layout/Title";
import Nav from "components/Nav";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Item from "../components/Item";
import SubNavLink from "../components/SubNavLink";

import {
    colorWalnuts,
    colorAlmonds,
    colorFlax,
    colorChia,
} from "sass/partials/_variables.scss";

const Fats = () => {
    return (
        <FadeIn>
            <Nav fats={true} />
            <main>
                <article className="page">
                    <Title
                        bg="https://upload.wikimedia.org/wikipedia/commons/7/70/Toicon-icon-avocado-eat.svg"
                        bgSize="60%"
                        bgRepeat="no-repeat"
                        bgPos="center 70%"
                    >
                        Fats
                    </Title>
                    <div>
                        <h2 className="introtext">So you might ask:</h2>
                        <h3 className="introtext">Why do we need them?</h3>
                        <h4 className="introtext">
                            Energy is stored as fat in our bodies, but some
                            nutrients called essential fatty acids are not
                            self-manufactured so foods containing dietary fat
                            must be consumed. Dietary fat is important to
                            bodybuilders because it helps keep the blood
                            flowing, the heart beating correctly and keeps the
                            skin and hair healthy.
                            <sup>
                                <AnchorLink
                                    href="https://www.bodybuilding.com/fun/dietary_fat_importance.htm"
                                    title="content from bodybuilding.com"
                                >
                                    1
                                </AnchorLink>
                            </sup>
                        </h4>

                        <nav className="subnav subnav-list">
                            <SubNavLink
                                text="Walnuts"
                                shortName="walnuts"
                                color={colorWalnuts}
                            />
                            <SubNavLink
                                text="Almonds"
                                shortName="almonds"
                                color={colorAlmonds}
                            />
                            <SubNavLink
                                text="Flax seeds"
                                shortName="flax"
                                color={colorFlax}
                            />

                            <SubNavLink
                                text="Chia seeds"
                                shortName="chia"
                                color={colorChia}
                            />
                        </nav>
                    </div>

                    <Item
                        title="Walnuts"
                        subtitle="100g"
                        shortName="walnuts"
                        color={colorWalnuts}
                        img={walnutsImg}
                        data={[
                            { name: "Kcal", stat: "654" },
                            { name: "Fats", stat: "65 g" },
                        ]}
                    />

                    <Item
                        title="Almonds"
                        subtitle="100g"
                        shortName="almonds"
                        color={colorAlmonds}
                        img={almondsImg}
                        data={[
                            { name: "Kcal", stat: "575" },
                            { name: "Fats", stat: "49 g" },
                        ]}
                    />

                    <Item
                        title="Flax"
                        subtitle="100g"
                        shortName="flax"
                        color={colorFlax}
                        img={flaxImg}
                        data={[
                            { name: "Kcal", stat: "512" },
                            { name: "Fats", stat: "42 g" },
                        ]}
                    />

                    <Item
                        title="Chia"
                        subtitle="100g"
                        shortName="chia"
                        color={colorChia}
                        img={chiaImg}
                        data={[
                            { name: "Kcal", stat: "442" },
                            { name: "Fats", stat: "30,7 g" },
                        ]}
                    />
                </article>
            </main>
        </FadeIn>
    );
};

export default Fats;
